import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  CardFooter,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import JobListingService from "../../../services/KangarooServices/JobListingService";
import { useParams } from "react-router-dom";
import { formatDate } from "../../../Components/Common/FormatDate";

export default function JobDetail() {
  const { id } = useParams();
  // Static data
  const [details, setDetails] = useState({});

  const fetchDetails = async (id) => {
    try {
      const response = await JobListingService.getDetail(id);
      setDetails(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (id) fetchDetails(id);
  }, [id]);

  return (
    <div className="page-content">
      <Container fluid className="">
        <BreadCrumb
          title="Job Detail"
          pageTitle="Job Listing"
          breadcrumbItems={[{ title: "Back to List", link: "/joblisting" }]}
        />

        <Row className="justify-content-center">
          <Col lg={12} xl={12}>
            {/* Header Card */}
            <Card className="border-0 shadow-sm mb-4">
              <CardBody className="p-4">
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3">
                  <div>
                    <Badge
                      pill
                      className={`px-2 py-1 ${
                        details?.status === 1
                          ? "bg-success-subtle text-success"
                          : "bg-danger-subtle text-danger"
                      }`}
                    >
                      <i
                        className={`ri-checkbox-blank-circle-fill me-1 small`}
                      ></i>
                      {details?.status === 1
                        ? "Receiving Applicants"
                        : "Closed"}
                    </Badge>
                    <h2 className="fw-bold mb-2">{details.position}</h2>
                    <p className="text-muted mb-0">
                      <i className="ri-group-line me-2"></i>
                      {details.slotsLeft} slots left
                    </p>
                  </div>
                  <Button color="primary" size="lg" className="px-4">
                    <i className="ri-send-plane-line me-2"></i>
                    Apply Now
                  </Button>
                </div>
              </CardBody>
              <CardFooter>
                <div className="d-flex align-items-center ">
                  <i className="ri-calendar-check-line text-primary fs-4 me-1"></i>
                  <span className="text-muted me-1">Published: </span>
                  <p className="fw-semibold mb-0">
                    {formatDate(details.publishedDate)}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  <i className="ri-calendar-line text-success fs-4 me-1"></i>
                  <span className="text-muted me-1">Deadline: </span>
                  <p className="fw-semibold mb-0">
                    {formatDate(details.deadline)}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  <i className="ri-timer-line text-danger fs-4 me-1"></i>
                  <span className="text-muted me-1">Time Left: </span>
                  <p className="fw-semibold mb-0">{details.daysLeft}</p>
                </div>
              </CardFooter>
            </Card>

            {/* Quick Info Cards */}
            {/* <Row className="g-3 mb-4">
              <Col md={4}>
                <Card className="border shadow-sm ">
                  <CardBody className="text-center">
                    <i className="ri-calendar-check-line text-primary fs-3 mb-2"></i>
                    <h6 className="text-muted ">Published</h6>
                    <p className="fw-semibold mb-0">{details.publishedDate}</p>
                  </CardBody>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="border shadow-sm ">
                  <CardBody className="text-center">
                    <i className="ri-time-line text-danger fs-3 mb-2"></i>
                    <h6 className="text-muted mb-1">Deadline</h6>
                    <p className="fw-semibold mb-0">{details.deadline}</p>
                  </CardBody>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="border shadow-sm ">
                  <CardBody className="text-center">
                    <i className="ri-hourglass-line text-warning fs-3 mb-2"></i>
                    <h6 className="text-muted mb-1">Time Left</h6>
                    <p className="fw-semibold mb-0">{details.daysLeft}</p>
                  </CardBody>
                </Card>
              </Col>
            </Row> */}

            {/* Job Description */}
            <Card className="border shadow-sm mb-4">
              <CardBody className="p-4">
                <h4 className="fw-bold mb-3">
                  <i className="ri-file-text-line text-primary me-2"></i>
                  Job Description
                </h4>
                <div
                  className="text-muted lh-lg"
                  dangerouslySetInnerHTML={{ __html: details.jobDescription }}
                />{" "}
              </CardBody>
            </Card>

            {/* Experience Required */}
            <Card className="border shadow-sm mb-4">
              <CardBody className="p-4">
                <h4 className="fw-bold mb-3">
                  <i className="ri-briefcase-line text-primary me-2"></i>
                  Experience Required
                </h4>
                <p className="text-muted mb-0">{details.experience}</p>
              </CardBody>
            </Card>

            {/* Specifications */}
            <Card className="border shadow-sm mb-4">
              <CardBody className="p-4">
                <h4 className="fw-bold mb-3">
                  <i className="ri-list-check text-primary me-2"></i>
                  Key Specifications
                </h4>
                <div
                  className="text-muted lh-lg"
                  dangerouslySetInnerHTML={{
                    __html: details.jobSpecifications,
                  }}
                />

                {/* <ul className="list-unstyled mb-0">
                  {details.map((spec, index) => (
                    <li key={index} className="mb-2 d-flex align-items-start">
                      <i className="ri-checkbox-circle-fill text-success me-2 mt-1"></i>
                      <span className="text-muted">{spec}</span>
                    </li>
                  ))}
                </ul> */}
              </CardBody>
            </Card>

            {/* Education */}
            <Card className="border shadow-sm mb-4">
              <CardBody className="p-4">
                <h4 className="fw-bold mb-3">
                  <i className="ri-book-open-line text-primary me-2"></i>
                  Education Requirement
                </h4>
                <p className="text-muted mb-0">{details.education}</p>
              </CardBody>
            </Card>

            {/* Apply Section */}
            {/* <Card className="border-0 shadow-sm bg-light">
              <CardBody className="p-4 text-center">
                <h5 className="fw-bold mb-3">Ready to Apply?</h5>
                <p className="text-muted mb-4">
                  Don't miss this opportunity! Submit your application before the deadline.
                </p>
                <Button color="primary" size="lg" className="px-5">
                  <i className="ri-send-plane-line me-2"></i>
                  Apply for this Position
                </Button>
              </CardBody>
            </Card> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
